import './index.scss';
import FilteredMultiSelect from 'react-filtered-multiselect';
import PropTypes from 'prop-types';
import React from 'react';

const FilteredTwoColumnMultiSelect = props => (

    <div className="filtered-multi-select">
        <label className="label">{props.label}</label>
        <div>
            <FilteredMultiSelect
                onChange={props.onChange}
                options={props.options}
                textProp={props.textProp}
                valueProp={props.valueProp}
                className="custome-filter-multi-select"
                disabled={props.disabled}
                selectedOptions={props.selectedOptions}
            />
            <div className="filtered-options">
                <div className="top-part">
                    {props.selectedOptions.length === 0 &&
                        <p>None Selected</p>}
                    {props.selectedOptions.length > 0 && (
                        <>
                            {props.selectedOptions.map( ( ship, i ) => (
                                <div className="selected-box">
                                    <span className="text-val">{`${ship.label} `}</span>
                                    <span
                                        className="close-btn"
                                        onClick={() => props.handleDeselect( i )}
                                    >
                                        <i className="fa fa-times" aria-hidden="true" />
                                    </span>
                                </div>
                            ) ) }
                        </>
                    )}
                </div>
                <button
                    type="button"
                    onClick={() => props.handleClearAll()}
                    disabled={props.selectedOptions.length === 0}
                >Clear All
                </button>
            </div>
        </div>
    </div>

);
FilteredTwoColumnMultiSelect.displayName = 'FilteredTwoColumnMultiSelect';
FilteredTwoColumnMultiSelect.propTypes = {
    label: PropTypes.string.isRequired,
    textProp: PropTypes.string.isRequired,
    valueProp: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    handleClearAll: PropTypes.func.isRequired,
    handleDeselect: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    selectedOptions: PropTypes.array,

};
export default FilteredTwoColumnMultiSelect;
